import React from "react";
import { Card, Alert } from "react-bootstrap";

function SchedulersOverview() {
  return (
    <div>
      <h2 className="mb-4">Schedulers Overview</h2>

      <Alert variant="info">
        Schedulers allow you to automate runbook execution by setting up recurring schedules using cron expressions.
      </Alert>

      <Card className="mb-4">
        <Card.Body>
          <h4>What is a Scheduler?</h4>
          <p>
            A scheduler is an automated trigger that runs a runbook at specific times or intervals. Instead of manually
            executing a runbook, you can set it to run automatically on a schedule - for example, every day at 9 AM,
            or every Monday at 8 PM.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Viewing Your Schedulers</h4>
          <ol>
            <li>Click <strong>My Schedulers</strong> in the left menu</li>
            <li>You'll see a grid showing all configured schedules</li>
            <li>Each schedule shows:
              <ul className="mt-2">
                <li>Scheduler ID</li>
                <li>Associated runbook</li>
                <li>Schedule (cron expression translated to plain English)</li>
                <li>Next execution time</li>
                <li>Timezone</li>
                <li>Who created it</li>
              </ul>
            </li>
          </ol>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Understanding Cron Expressions</h4>
          <p>
            Schedules use "cron expressions" to define when runbooks should execute. Don't worry - you don't need to
            learn cron syntax! The portal provides a visual editor and shows you a human-readable translation of the schedule.
          </p>
          <p className="mt-3">
            Examples of common schedules:
          </p>
          <ul>
            <li><strong>Every day at 9:00 AM</strong> - Daily morning execution</li>
            <li><strong>Every Monday at 6:00 PM</strong> - Weekly execution</li>
            <li><strong>Every hour</strong> - Hourly execution</li>
            <li><strong>First day of every month at 12:00 AM</strong> - Monthly execution</li>
          </ul>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Timezone Considerations</h4>
          <p>
            Each scheduler has a timezone setting. This ensures your runbooks execute at the correct local time,
            regardless of where the server is located. Make sure to select the appropriate timezone when creating a schedule.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Scheduler Actions</h4>
          <p>Available actions for schedulers:</p>
          <ul>
            <li><strong>Edit</strong> - Modify the schedule or change the runbook</li>
            <li><strong>Delete</strong> - Remove the schedule (the runbook itself is not deleted)</li>
          </ul>
          <p className="mt-3">
            <em>Note: Available actions depend on your user permissions.</em>
          </p>
        </Card.Body>
      </Card>
    </div>
  );
}

export default SchedulersOverview;
